import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHabrComponent } from './simple-icons-habr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHabrComponent ],
    exports:      [ SimpleIconsHabrComponent ],
    bootstrap:    []
})
export class SimpleIconsHabrModule {}
